import { render, staticRenderFns } from "./UploadSuccess.vue?vue&type=template&id=52a646ff&scoped=true&"
import script from "./UploadSuccess.vue?vue&type=script&lang=js&"
export * from "./UploadSuccess.vue?vue&type=script&lang=js&"
import style0 from "./UploadSuccess.vue?vue&type=style&index=0&id=52a646ff&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a646ff",
  null
  
)

export default component.exports